import { useEffect } from 'react';

import { useHomeGamesWidget } from '@swf/poker';

const useSetLoadingOnUnmount = (loaderName: string) => {
  const { widgetDispatch } = useHomeGamesWidget();

  useEffect(
    () => () => {
      widgetDispatch.setLoading({ isLoading: true, loaderName });
    },
    [loaderName, widgetDispatch]
  );
};

export default useSetLoadingOnUnmount;
